module.exports = __webpack_public_path__ + "img/106.1aa5e634.png";